export default __webpack_public_path__ + "static/media/mobile_78.50e7434a.jpg";